import React from 'react';
import { Button, Segmented, Slider } from 'antd';
import { Rows3, LayoutGrid } from 'lucide-react';
import styles from './index.module.css';

export enum FeedbackViewMode {
  List = 'list',
  Card = 'card'
}

type Props = {
  onClick: () => void;
  fullArchive: boolean;
  isArchiveViewActive: boolean;
  cardViewEnabled: boolean;
  viewMode: FeedbackViewMode;
  onViewModeChange: (mode: FeedbackViewMode) => void;
  cardScale: number;
  onCardScaleChange: (scale: number) => void;
  cardScaleMin: number;
  cardScaleMax: number;
};

export const ListHeader: React.FC<Props> = ({
  onClick,
  fullArchive,
  isArchiveViewActive,
  cardViewEnabled,
  viewMode,
  onViewModeChange,
  cardScale,
  onCardScaleChange,
  cardScaleMin,
  cardScaleMax
}) => {
  return (
    <div className={styles.headerContainer}>
      {isArchiveViewActive ? (
        <>
          <h3 className={styles.header}>Archived Tasks</h3>
          {!fullArchive && (
            <Button type="text" onClick={onClick}>
              Only searching most recent 100, click to search whole archive
            </Button>
          )}
        </>
      ) : (
        <div className={styles.headerInner}>
          <h3 className={styles.header}>Feedback</h3>
        </div>
      )}
      {cardViewEnabled && (
        <div className={styles.viewControls}>
          {viewMode === FeedbackViewMode.Card && (
            <Slider
              className={styles.cardScaleSlider}
              min={cardScaleMin}
              max={cardScaleMax}
              step={10}
              value={cardScale}
              onChange={onCardScaleChange}
              tooltip={{ formatter: null }}
              aria-label="Card size"
            />
          )}
          <Segmented
            className={styles.viewModeToggle}
            value={viewMode}
            onChange={value => onViewModeChange(value as FeedbackViewMode)}
            options={[
              {
                label: 'List',
                value: FeedbackViewMode.List,
                icon: <Rows3 size={14} className={styles.viewModeToggleIcon} />
              },
              {
                label: 'Card',
                value: FeedbackViewMode.Card,
                icon: (
                  <LayoutGrid
                    size={14}
                    className={styles.viewModeToggleIcon}
                  />
                )
              }
            ]}
          />
        </div>
      )}
    </div>
  );
};
